import React from 'react';
import {
  MEMBERSHIP_COST_COMPARISON,
  NEEDS_ASSESSMENT_PDF_URL,
  NEEDS_ASSESSMENT_SOURCE_LABEL,
} from './homePageConstants';

function formatUsd(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
}

type MembershipCostComparisonContentProps = {
  headingLevel?: 'h2' | 'h3';
  className?: string;
};

export const MembershipCostComparisonContent: React.FC<MembershipCostComparisonContentProps> = ({
  headingLevel = 'h3',
  className = '',
}) => {
  const Heading = headingLevel;

  return (
    <div className={`membership-cost-comparison ${className}`.trim()}>
      <Heading className="membership-cost-comparison__title">Membership cost comparison</Heading>
      <p className="membership-cost-comparison__intro">{MEMBERSHIP_COST_COMPARISON.intro}</p>
      <div className="membership-cost-comparison__table-wrap">
        <table className="membership-cost-comparison__table">
          <thead>
            <tr>
              {MEMBERSHIP_COST_COMPARISON.columns.map((column) => (
                <th key={column} scope="col">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MEMBERSHIP_COST_COMPARISON.rows.map((row) => (
              <tr key={row.population}>
                <th scope="row">{row.population}</th>
                <td>{formatUsd(row.ghgInventoryCost)}</td>
                <td>{formatUsd(row.affiliateFee)}</td>
                <td>{row.affiliatePct}</td>
                <td>{formatUsd(row.capCost)}</td>
                <td>{formatUsd(row.regularFee)}</td>
                <td>{row.regularPct}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="membership-cost-comparison__note">{MEMBERSHIP_COST_COMPARISON.disclaimer}</p>
      <p className="membership-cost-comparison__source">
        Source:{' '}
        <a href={NEEDS_ASSESSMENT_PDF_URL} target="_blank" rel="noopener noreferrer">
          {NEEDS_ASSESSMENT_SOURCE_LABEL}
        </a>
      </p>
    </div>
  );
};
